module.exports = __webpack_public_path__ + "static/media/Bluelab pH Probe 5M.342198bd.webp";